'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CatalogSearchRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogSearchRemote = exports.CatalogSearchRemote = {
    fetchCatalogsTodayCount: function fetchCatalogsTodayCount(deployment) {
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({ deployment: deployment, path: '<ITEM-API>spa/small/catalogtodaycount' });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchSearchResults: function fetchSearchResults(_ref) {
        var deployment = _ref.deployment,
            searchParams = _ref.searchParams;

        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({ apiPath: 'auctioncalendar', deployment: deployment, path: '<AUCTION-CALENDAR-API>' });
            request.query(searchParams);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/catalogSearch.js
// module id = 2eK9
// module chunks = 60